import React, {ComponentType} from "react"

export const retryImport = (componentImport) => {
    return new Promise((resolve, reject) => {
        const hasRefreshed = JSON.parse(
            globalThis.sessionStorage.getItem("retry-lazy-refreshed") || "false"
        )
        componentImport()
            .then((component) => {
                globalThis.sessionStorage.setItem("retry-lazy-refreshed", "false")
                resolve(component)
            })
            .catch((error) => {
                if (!hasRefreshed) {
                    globalThis.sessionStorage.setItem("retry-lazy-refreshed", "true")
                    return globalThis.location.reload()
                }
                reject(error)
            })
    }) as Promise<{default: ComponentType<any>}>
}

export const reactLazyRetry = (componentImport) => React.lazy(() => retryImport(componentImport))
